/* eslint-disable no-nested-ternary */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import handleKeyPress from '../../../../../../../../common/handleKeyPress';
import eventService from '../../../../../../../../common/eventService';
import { ERR_PARAGRAPH_INLINE_BOLD } from '../../../../../../../../constants/Errors';

class Option extends Component {
    state = {
        disabled: false,
    };

    static propTypes = {
        onClick: PropTypes.func.isRequired,
        children: PropTypes.any,
        value: PropTypes.string,
        active: PropTypes.bool,
        title: PropTypes.string,
    };

    componentDidMount() {
        const { title } = this.props;
        const textElement = document.getElementsByClassName('current-text-element-type')[0];
        const textElementIsHeader = !textElement ? true : textElement.innerText.includes('Header');
        const disabled = textElementIsHeader && title === 'Bold'; // disabling bold option for headers as it does nothing
        this.setState({ disabled });
    }

    onClick = () => {
        const { onClick, value } = this.props;
        const { disabled } = this.state;
        if (disabled) {
            eventService.notify(ERR_PARAGRAPH_INLINE_BOLD, true);
            return;
        }

        onClick(value);
    };

    render() {
        const { children, active, title } = this.props;
        const { disabled } = this.state;
        const className = disabled
            ? 'rdw-option-wrapper draftButton'
            : active
            ? 'rdw-option-wrapper draftButton rdw-option-active'
            : 'rdw-option-wrapper draftButton';
        return (
            // eslint-disable-next-line jsx-a11y/interactive-supports-focus
            <div
                data-tip
                data-for={`textStyle${title}`}
                className={className}
                onClick={this.onClick}
                onKeyDown={(e) => handleKeyPress(e, this.onClick)}
                aria-pressed={active}
                role="button"
                style={{
                    opacity: disabled ? 0.1 : 1,
                    height: 20,
                    lineHeight: '20px',
                }}
            >
                {children}
                {!disabled && (
                    <ReactTooltip id={`textStyle${title}`} place="top" effect="solid">
                        <span style={{ fontWeight: 'bold' }}>{title}</span>
                    </ReactTooltip>
                )}
            </div>
        );
    }
}

const Inline = (props) => {
    const { config, currentState, onChange } = props;

    return (
        <div className="rdw-inline-wrapper borderLeft" aria-label="rdw-inline-control">
            {config.options.map((style, index) => (
                <Option
                    key={index}
                    value={style}
                    onClick={onChange}
                    active={currentState[style] === true}
                    title={config[style].title}
                >
                    <img alt={`textStyle${config[style].title}`} src={config[style].icon} />
                </Option>
            ))}
        </div>
    );
};

Inline.propTypes = {
    config: PropTypes.shape({
        component: PropTypes.func.isRequired,
        options: PropTypes.arrayOf(PropTypes.string).isRequired,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    currentState: PropTypes.shape({
        bold: PropTypes.bool,
        italic: PropTypes.bool,
        underline: PropTypes.bool,
    }).isRequired,
};

export default Inline;
